import React, { memo, useState } from 'react';
import { Tooltip } from '@nexus/lib-react/dist/legacy/Tooltip/Tooltip';
import { EyeHidden } from './style/Dac7Profile';
import { useI18n } from '../../../../../i18n';

const Dac7EyeHiddenTooltip = () => {
  const i18n = useI18n();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <Tooltip
      visible={isOpen}
      position="top"
      onClickOutside={() => setIsOpen(false)}
      onOpen={() => {
        setIsOpen(true);
      }}
      toggleNode={<EyeHidden />}
    >
      {i18n(`dlv_dac7_profile_eye_hidden_tooltip`)}
    </Tooltip>
  );
};

export default memo(Dac7EyeHiddenTooltip);
